import { t } from '../locale'

function NotFound() {
  return (
    <div className='col text-center'>
      <h3>404 | {t('pageNotFound')}</h3>
    </div>
  )
}

export default NotFound
